import AnimatedArrow from "./AnimatedArrow";

export default function ContactUs({ title = "" }) {
  return (
    <div className="py-36 px-4 lg:px-0">
      <div className="text-5xl sm:text-6xl text-white leading-snug">
        {title}
      </div>
      <div className="inline-block">
        <a
          href="mailto:contact@calips.io"
          className="group flex flex-row items-center p-4 gap-4 bg-[#1b1b1b] mt-8 cursor-pointer transition-all hover:opacity-90"
        >
          <div className="text-white">Contact us</div>
          <AnimatedArrow />
        </a>
      </div>
    </div>
  );
}
